import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7cec8bb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "FgElementWrapper" }
const _hoisted_2 = ["value"]
const _hoisted_3 = {
  key: 0,
  class: "ErrorMessage"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ 'is-Not-Valid': _ctx.showNameError }, "NameInputWrapper"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("input", {
        onBlur: _cache[0] || (_cache[0] = ($event: any) => (_ctx.saveName(true, $event))),
        onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setFocused(true))),
        onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.saveName(false, $event))),
        class: _normalizeClass([{ HasFocus: _ctx.hasFocus, HasValue: _ctx.name }, "NameInput FgInput js-Input"]),
        value: _ctx.name,
        "aria-label": "Name",
        "data-cy": "NameInput",
        name: "Name",
        type: "text",
        ref: "input"
      }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_2),
      _createElementVNode("label", {
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.setFocusOnInput && _ctx.setFocusOnInput(...args))),
        class: "FgLabel",
        for: "nameInput"
      }, "Name")
    ]),
    (_ctx.showNameError)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, " Please enter a name "))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}